export default "__VITE_ASSET__60a17225__"